var map = {
	"./doc-1.jpg": "2ac9",
	"./doc-2.jpg": "a588",
	"./gentlemen.jpg": "a7ed",
	"./head/man.jpg": "b87c",
	"./head/woman.jpg": "b790",
	"./lady.jpg": "86ce",
	"./pdf4.jpg": "c6cf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";